import { CSSProperties } from 'react';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { ListingRequestAdminHeaderButtonsComponent } from './listing-request-admin-header-buttons.component';
import { ListingRequestHeaderButtonsComponent } from './listing-request-header-buttons.component';
import { ListingRequestLeftHeaderComponent } from './listing-request-left-header.component';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const containerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr auto',
    columnGap: '20px',
    padding: '10px 20px',
    position: 'relative',
    background: 'white',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.1) 0px 1px 3px',
    zIndex: 101,
    height: '70px',
    minHeight: '70px',
    alignItems: 'center',
};

export const ListingRequestHeaderComponent = () => {
    const { hasPermission } = useActiveUserContext();
    //TODO PERMFE - redo with permissions+
    const headerButtons = hasPermission(PermissionsEnum.SubmissionsActAdv) ? (
        <ListingRequestAdminHeaderButtonsComponent />
    ) : (
        <ListingRequestHeaderButtonsComponent />
    );

    return (
        <div style={containerStyle} className="do-not-print">
            <ListingRequestLeftHeaderComponent />

            <div>{headerButtons}</div>
        </div>
    );
};
